export enum PositionEnum {
    Start = "start",
    Stop = "stop",
}
